import { Message, MessageAndIdModel } from "../../../domain/model/Auth";
import {
  Question,
} from "../../../domain/model/Question";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { QuestionRepository } from "./QuestionRepository";

export class QuestionRepositoryImpl implements QuestionRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  createQuestion(question: Question): Promise<Response<MessageAndIdModel>> {
    return this.apiService.createQuestion(question);
  }
  getQuestions(
    skip?: number,
    limit?: number,
  ): Promise<Response<Array<Question>>> {
    return this.apiService.getQuestions(skip, limit);
  }
  getQuestion(id: string): Promise<Response<Question>> {
    return this.apiService.getQuestion(id);
  }
  filterQuestionsBy(queryString: string): Promise<Response<Array<Question>>> {
    return this.apiService.filterQuestionsBy(queryString);
  }
  updateQuestion(question: Question): Promise<Response<Message>> {
    return this.apiService.updateQuestion(question);
  }
  deleteQuestion(id: string): Promise<Response<Message>> {
    return this.apiService.deleteQuestion(id);
  }
  deleteQuestionAttachment(id: string): Promise<Response<Message>> {
    return this.apiService.deleteQuestionAttachment(id);
  }
}
